import Checkbox from '../../Forms/Input/Checkbox';
import { AllowedOptionColumn } from '../types';

type Props = {
  allChecked: boolean;
  onToggleAll: (checked: boolean) => void;
  columns: AllowedOptionColumn[];
};

const TableHeader: React.FC<Props> = ({
  allChecked,
  onToggleAll,
  columns,
}) => {
  return (
    <thead>
      <tr className="text-gray-700 dark:text-gray-300 bg-[#f8f9fc] text-sm dark:bg-[#0f172a]">
        <th className="w-[48px] py-2.5 pl-4 pr-2">
          <Checkbox
            id="select-all"
            checked={allChecked}
            onChange={() => onToggleAll(!allChecked)}
          />
        </th>
        {columns.map((col, idx) => (
          <th
            key={idx}
            className="px-4 py-2.5 text-left text-xs font-semibold tracking-wide"
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
